import Analytics, { type AnalyticsPlugin } from 'analytics';
import simpleAnalyticsPlugin from '@analytics/simple-analytics';

const isProduction = window.location.hostname === 'app.thedmsark.com';
const plugins: AnalyticsPlugin[] = isProduction
  ? [simpleAnalyticsPlugin() as unknown as AnalyticsPlugin]
  : [];

const analytics = Analytics({
  app: 'app.thedmsark.com',
  plugins
});

function normalizePath(path: string): string {
  if (path.startsWith('/shared/')) {
    return '/shared/***';
  } else if (/^\/campaigns\/[^/]+$/.exec(path)) {
    return '/campaigns/***';
  } else if (/^\/sessions\/[^/]+\/transcript$/.exec(path)) {
    return '/sessions/***/transcript';
  } else if (/^\/campaigns\/[^/]+\/sessions\/create$/.exec(path)) {
    return '/campaigns/***/sessions/create';
  }
  return path;
}

const IGNORE_PATHS = ['/callback', '/'];

export const trackPageView = (path: string) => {
  if (!isProduction) {
    return;
  }

  if (IGNORE_PATHS.includes(path)) {
    return;
  }

  try {
    const normalizedPath = normalizePath(path);
    analytics.page({
      path: normalizedPath
    });
  } catch (error) {
    console.warn('Analytics page tracking failed:', error);
  }
};

export const identifyUser = (userId: string, userTraits?: Record<string, unknown>) => {
  if (!isProduction) {
    return;
  }

  try {
    analytics.identify(userId, userTraits);
  } catch (error) {
    console.warn('Analytics user identification failed:', error);
  }
};

export const trackEvent = (eventName: string, properties?: Record<string, unknown>) => {
  if (!isProduction) {
    return;
  }

  try {
    analytics.track(eventName, properties);
  } catch (error) {
    console.warn('Analytics event tracking failed:', error);
  }
};

export default analytics;
